// src/app/app.component.ts
import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { MsalService } from '@azure/msal-angular'
import { DEPLOYMENT_ENVIRONMENT } from '../../../config/environment'

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0', '::1'])

function isLocalHost(hostname: string): boolean {
  const normalized = hostname.toLowerCase()
  return (
    LOCAL_HOSTS.has(normalized) ||
    normalized.endsWith('.localhost') ||
    normalized.endsWith('.local')
  )
}

@Component({
  selector: 'app-wrapper',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>',
})
export class WrapperComponent {
  constructor(private msal: MsalService) {
    const isLocal =
      DEPLOYMENT_ENVIRONMENT === 'local' ||
      isLocalHost(location.hostname)
    const isEmbedded = /^\/embed-(?:view|legal|operations|merchant|all)$/.test(
      location.pathname,
    )
    if (isLocal || isEmbedded) {
      return
    }

    const account = this.msal.instance.getActiveAccount()
    const allAccounts = this.msal.instance.getAllAccounts()

    if (!account && allAccounts.length > 0) {
      this.msal.instance.setActiveAccount(allAccounts[0])
    }

    if (!this.msal.instance.getActiveAccount()) {
      console.log('[MSAL] No active account — redirecting to login')
      this.msal.loginRedirect()
    } else {
      console.log(
        '[MSAL] Authenticated as',
        this.msal.instance.getActiveAccount(),
      )
    }
  }
}
